export default [
  {
    path: '/appreciations',
    name: 'appreciation',
    meta: { requiresAuth: true },
    component: () => import('@/pages/appreciation/index.vue')
  }
]
